import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'

import VueTheMask from 'vue-the-mask'
import VueAWN from "vue-awesome-notifications"
import VeeValidate from 'vee-validate'
import VueAnalytics from 'vue-analytics'

import { compareAsc } from 'date-fns'

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

if(process.env.NODE_ENV === 'production'){
    Sentry.init({
        environment: process.env.NODE_ENV,
        dsn: 'https://00dff207dfce4678a00e0d272f5a102f@sentry.io/1529544',
        integrations: [new Integrations.Vue({Vue, attachProps: true, logErrors: true})],
    })
}


VeeValidate.Validator.extend('nif', (value) => {
    if(value.length === 14){
        /*
         *  CPF validation
         */

        var numeros, digitos, soma, i, resultado, digitos_iguais
        digitos_iguais = 1
        let cpf = value.replace(/[^\d]+/g,'')

        for (i = 0; i < value.length - 1; i++)
            if (cpf.charAt(i) != cpf.charAt(i + 1))
            {
                digitos_iguais = 0
                break
            }

        if (!digitos_iguais){
            numeros = cpf.substring(0,9)
            digitos = cpf.substring(9)
            soma = 0

            for (i = 10; i > 1; i--){
                soma += numeros.charAt(10 - i) * i
            }

            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11

            if (resultado != digitos.charAt(0)){
                return false
            }

            numeros = cpf.substring(0,10)
            soma = 0
            for (i = 11; i > 1; i--){
                soma += numeros.charAt(11 - i) * i
            }

            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11

            if (resultado != digitos.charAt(1)){
                return false
            }

            return true
        }
    } else if(value.length === 18) {
        /*
         *  CNPJ validation
         */
        let cnpj = value.replace(/[^\d]+/g,'')

        if(cnpj == ''){
            return false
        }

        if (cnpj.length != 14){
            return false
        }

        if (cnpj == "00000000000000" ||
            cnpj == "11111111111111" ||
            cnpj == "22222222222222" ||
            cnpj == "33333333333333" ||
            cnpj == "44444444444444" ||
            cnpj == "55555555555555" ||
            cnpj == "66666666666666" ||
            cnpj == "77777777777777" ||
            cnpj == "88888888888888" ||
            cnpj == "99999999999999"){
            return false
        }

        let tamanho = cnpj.length - 2
        let numeros = cnpj.substring(0,tamanho)
        let digitos = cnpj.substring(tamanho)
        let soma = 0
        let pos = tamanho - 7

        for (i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--
            if (pos < 2){
                pos = 9
            }
        }

        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11

        if (resultado != digitos.charAt(0)){
            return false
        }

        tamanho = tamanho + 1
        numeros = cnpj.substring(0,tamanho)
        soma = 0
        pos = tamanho - 7
        for (i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--

            if (pos < 2){
                pos = 9
            }
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11

        if (resultado != digitos.charAt(1)){
            return false
        }

        return true
    } else {
        return false
    }
})

VeeValidate.Validator.extend('due', (value) => {
    var today, someday;
    var parts = value.split('/')

    today   = new Date()
    someday = new Date()

    var currentCentury = Math.floor(someday.getFullYear() / 100)
    someday.setFullYear(parseInt(currentCentury.toString() + parts[1]), parseInt(parts[0]), 1)

    return compareAsc(today, someday) === -1
})

import validatorMssagesPt from 'vee-validate/dist/locale/pt_BR'
import validatorMssagesEn from 'vee-validate/dist/locale/en'
import validatorMssagesEs from 'vee-validate/dist/locale/es'

import 'element-ui/lib/theme-chalk/row.css'
import 'element-ui/lib/theme-chalk/col.css'
import 'element-ui/lib/theme-chalk/reset.css'
import 'element-ui/lib/theme-chalk/card.css'
import 'element-ui/lib/theme-chalk/table.css'
import 'element-ui/lib/theme-chalk/table-column.css'
import 'element-ui/lib/theme-chalk/tag.css'
import 'element-ui/lib/theme-chalk/alert.css'
import 'element-ui/lib/theme-chalk/form.css'
import 'element-ui/lib/theme-chalk/checkbox.css'
import 'element-ui/lib/theme-chalk/form-item.css'
import 'element-ui/lib/theme-chalk/select.css'
import 'element-ui/lib/theme-chalk/option.css'
import 'element-ui/lib/theme-chalk/dropdown.css'
import 'element-ui/lib/theme-chalk/dropdown-menu.css'
import 'element-ui/lib/theme-chalk/dropdown-item.css'
import 'element-ui/lib/theme-chalk/button.css'
import 'element-ui/lib/theme-chalk/radio-button.css'
import 'element-ui/lib/theme-chalk/radio-group.css'
import 'element-ui/lib/theme-chalk/input.css'
import 'element-ui/lib/theme-chalk/input-number.css'
import 'element-ui/lib/theme-chalk/radio.css'
import 'element-ui/lib/theme-chalk/link.css'
import 'element-ui/lib/theme-chalk/popover.css'
import 'element-ui/lib/theme-chalk/date-picker.css'
import 'element-ui/lib/theme-chalk/badge.css'
import 'element-ui/lib/theme-chalk/icon.css'
import 'element-ui/lib/theme-chalk/divider.css'
import 'element-ui/lib/theme-chalk/pagination.css'

import {
  Card,
  Table,
  TableColumn,
  Alert,
  Tag,
  Form,
  FormItem,
  Select,
  Option,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Button,
  RadioGroup,
  RadioButton,
  Input,
  InputNumber,
  Radio,
  Checkbox,
  Popover,
  Link,
  DatePicker,
  Badge,
  Icon,
  Col,
  Row,
  Divider,
  Pagination
} from 'element-ui'

Vue.component(Col.name, Col)
Vue.component(Row.name, Row)
Vue.component(Card.name, Card)
Vue.component(Table.name, Table)
Vue.component(TableColumn.name, TableColumn)
Vue.component(Alert.name, Alert)
Vue.component(Tag.name, Tag)
Vue.component(Form.name, Form)
Vue.component(FormItem.name, FormItem)
Vue.component(Select.name, Select)
Vue.component(Option.name, Option)
Vue.component(Dropdown.name, Dropdown)
Vue.component(DropdownMenu.name, DropdownMenu)
Vue.component(DropdownItem.name, DropdownItem)
Vue.component(Button.name, Button)
Vue.component(RadioGroup.name, RadioGroup)
Vue.component(RadioButton.name, RadioButton)
Vue.component(Input.name, Input)
Vue.component(InputNumber.name, InputNumber)
Vue.component(Radio.name, Radio)
Vue.component(Checkbox.name, Checkbox)
Vue.component(Link.name, Link)
Vue.component(Popover.name, Popover)
Vue.component(DatePicker.name, DatePicker)
Vue.component(Badge.name, Badge)
Vue.component(Icon.name, Icon)
Vue.component(Divider.name, Divider)
Vue.component(Pagination.name, Pagination)

import ElementUiLangPtBr from 'element-ui/lib/locale/lang/pt-br'
import ElementUiLocale from 'element-ui/lib/locale'

ElementUiLocale.use(ElementUiLangPtBr)

Vue.use(i18n)

Vue.use(VueTheMask)
Vue.use(VueAWN, {
  maxNotifications: 5,
  position: "top-right",
  labels: {
    info: "Informação",
    success: "Sucesso",
    warning: "Atenção",
    alert: "Erro",
    async: "Aguarde",
    confirm: "Confirmação necessária"
  },
  modal: {
    okLabel: "Confirmar",
    cancelLabel: "Cancelar"
  },
  messages: {
    async: "Enviando requisição para o servidor..."
  }
})

Vue.use(VeeValidate,
  {
    aria: true,
    classNames: {},
    classes: false,
    delay: 0,
    errorBagName: 'errors', // change if property conflicts
    events: 'change|input|blur',
    fieldsBagName: 'validators',
    inject: true,
    locale: 'pt',
    validity: false,
    i18nRootKey: 'validations', // the nested key under which the validation messages will be located
    i18n,
    dictionary: {
      en: validatorMssagesEn,
      pt: validatorMssagesPt,
      es: validatorMssagesEs,
    }
  })

Vue.use(VueTheMask)

import router from './router'
import store from './store'

Vue.config.productionTip = false

import './assets/scss/app.scss'

Vue.use(VueAnalytics, {
    id: 'UA-147710468-1'
})

new Vue({
  router,
  store,
  i18n,
  render: function (h) { return h(App) }
}).$mount('#app')
